import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "icon-area" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "content" };
const _hoisted_4 = { class: "label" };
const _hoisted_5 = { class: "value" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'SavedToSpendStatCard',
    props: {
        icon: {},
        label: {},
        value: {},
        variant: { default: 'gold' }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["stat-card", _ctx.variant])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: _ctx.icon,
                        alt: _ctx.label,
                        class: "stat-icon"
                    }, null, 8, _hoisted_2)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.label), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.value), 1)
                ])
            ], 2));
        };
    }
});
